export default [{  // 限时折扣活动列表
			path: 'limit_time_discount',
			name: 'm_limit_time_discount',
			component: () => import('@/pages/marketing/limit_time_discount')
	},  {  // 新建限时折扣活动
			path: 'limit_time_discount_add',
			name: 'limit_time_discount_add',
			meta: {
				title: '新建限时折扣活动'
			},
			component: () => import('@/pages/marketing/limit_time_discount_add')
	},  {  // 编辑限时折扣活动
			path: 'limit_time_discount_edit/:id',
			name: 'limit_time_discount_edit',
			meta: {
				title: '编辑限时折扣活动'
			},
			props: route => route.params,
			component: () => import('@/pages/marketing/limit_time_discount_edit')
	},  {  // 限时折扣活动详情
			path: 'limit_time_discount_detail/:id',
			name: 'limit_time_discount_detail',
			meta: {
				title: '限时折扣活动详情'
			},
			props: route => route.params,
			component: () => import('@/pages/marketing/limit_time_discount_detail')
	},	{  //秒杀活动列表
		path: 'activity_secondkill',
		name: 'm_activity_secondkill',
		component: () => import('@/pages/marketing/activity_secondkill')
	},  {  // 新建秒杀活动
		path: 'activity_secondkill_add',
		name: 'activity_secondkill_add',
		meta: {
			title: '新建秒杀活动'
		},
		component: () => import('@/pages/marketing/activity_secondkill_add')
	},  {  // 编辑秒杀活动
		path: 'activity_secondkill_edit/:id',
		name: 'activity_secondkill_edit',
		meta: {
			title: '编辑秒杀活动'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_secondkill_edit')
	},  {  // 秒杀活动详情
		path: 'activity_secondkill_detail/:id',
		name: 'activity_secondkill_detail',
		meta: {
			title: '秒杀活动详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_secondkill_detail')
	},
	{  //预售活动列表
		path: 'activity_presell',
		name: 'm_activity_presell',
		component: () => import('@/pages/marketing/activity_presell')
	},  {  // 新建预售活动
		path: 'activity_presell_add',
		name: 'activity_presell_add',
		meta: {
			title: '新建预售活动'
		},
		component: () => import('@/pages/marketing/activity_presell_add')
	},  {  // 编辑预售活动
		path: 'activity_presell_edit/:id',
		name: 'activity_presell_edit',
		meta: {
			title: '编辑预售活动'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_presell_edit')
	},  {  // 预售活动详情
		path: 'activity_presell_detail/:id',
		name: 'activity_presell_detail',
		meta: {
			title: '预售活动详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_presell_detail')
	}, {  // 满赠活动列表
		path: 'reward_gift',
		name: 'm_activity_gifts',
		component: () => import('@/pages/marketing/reward_gift')
	},  {  // 新建满赠活动
		path: 'reward_gift_add',
		name: 'reward_gift_add',
		meta: {
			title: '新建满赠活动'
		},
		component: () => import('@/pages/marketing/reward_gift_add')
	},  {  // 编辑满赠活动
		path: 'reward_gift_edit/:id',
		name: 'reward_gift_edit',
		meta: {
			title: '编辑满赠活动'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/reward_gift_edit')
	},  {  // 满赠活动详情
		path: 'reward_gift_detail/:id',
		name: 'reward_gift_detail',
		meta: {
			title: '满赠活动详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/reward_gift_detail')
	}, {  // 砍价活动列表
			path: 'activity_bargain',
			name: 'm_activity_bargain',
			component: () => import('@/pages/marketing/activity_bargain')
	},  {  // 新建砍价活动
		path: 'activity_bargain_add',
		name: 'activity_bargain_add',
		meta: {
			title: '新建砍价活动'
		},
		component: () => import('@/pages/marketing/activity_bargain_add')
	},  {  // 编辑砍价活动
		path: 'activity_bargain_edit/:id',
		name: 'activity_bargain_edit',
		meta: {
			title: '编辑砍价活动'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_bargain_edit')
	},  {  // 砍价活动详情
		path: 'activity_bargain_detail/:id',
		name: 'activity_bargain_detail',
		meta: {
			title: '砍价活动详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/activity_bargain_detail')
	}, {  //优惠券管理
		path: 'coupon',
		name: 'm_coupon',
		props: route => route.query,
		component: () => import('@/pages/marketing/coupon')
	}, {  // 优惠券列表
		path: 'coupon_list',
		props: route => route.query,
		component: () => import('@/pages/marketing/coupon_list')
	},  {  // 新建优惠券
		path: 'coupon_add',
		name: 'coupon_add',
		meta: {
			title: '新建优惠券'
		},
		component: () => import('@/pages/marketing/coupon_add')
	},  {  // 编辑优惠券
		path: 'coupon_edit/:id',
		name: 'coupon_edit',
		meta: {
			title: '编辑优惠券'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/coupon_edit')
	},  {  // 优惠券详情
		path: 'coupon_detail/:id',
		name: 'coupon_detail',
		meta: {
			title: '优惠券详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/coupon_detail')
	},  {  // 优惠券审核
		path: 'coupon_verify/:id',
		name: 'coupon_verify',
		meta: {
			title: '优惠券审核'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/coupon_verify')
	}, {  // 优惠券发放任务
		path: 'coupon_task',
		props: route => route.query,
		component: () => import('@/pages/marketing/coupon_task')
	},  {  // 新建发放任务
		path: 'coupon_task_add',
		name: 'coupon_task_add',
		meta: {
			title: '新建发放任务'
		},
		component: () => import('@/pages/marketing/coupon_task_add')
	},  {  // 编辑发放任务
		path: 'coupon_task_edit/:id',
		name: 'coupon_task_edit',
		meta: {
			title: '编辑发放任务'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/coupon_task_edit')
	},  {  // 发放任务详情
		path: 'coupon_task_detail/:id',
		name: 'coupon_task_detail',
		meta: {
			title: '发放任务详情'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/coupon_task_detail')
	},  {  // 发放任务审核
		path: 'coupon_task_verify/:id',
		name: 'coupon_task_verify',
		meta: {
			title: '发放任务审核'
		},
		props: route => route.params,
		component: () => import('@/pages/marketing/coupon_task_verify')
	}];